<template>
  <div class="container-fuild mt-5">
    <div class="container">
      <div
        class="page-hader-cf col-12 mb-5"
        :style="{
          'background-image':
            'url(' + require('/src/assets/img/new-themes-bg.jpg') + ')',
        }"
      >
        <h1 data-v-66f72552="">
          <h1>{{ this.$store.state.homeTitleX }}</h1>
        </h1>
      </div>

      <div class="col-12 pahe-header-content">
        <p>
          {{ this.$store.state.homeDescriptionX }}
        </p>
        <span
          v-if="
            this.$store.state.homeKeywordsX != null &&
            this.$store.state.homeKeywordsX != ''
          "
        >
          {{ this.$store.state.homeKeywordsX.split(",").join(", ") }}</span
        >
        <span v-else>{{
          this.$store.getters.getWordLocale("txt_ithalatci_ihracatci_uretici")
        }}</span>
      </div>
      <hr />
    </div>
  </div>

  <ForieLoader v-show="showLoader && this.$store.state.domainSystemX == 1" />
  <TeLoader v-show="showLoader && this.$store.state.domainSystemX == 2" />

  <div
    v-if="productsList.length > 0"
    v-bind:class="{ container: true, visibility: showLoader == true }"
  >
    <carousel
      :wrap-around="true"
      :settings="settings"
      :breakpoints="breakpoints"
    >
      <slide v-for="(product, pIndex) in productsList" :key="pIndex">
        <div class="carousel__item">
          <router-link
            :to="
              '/' +
              this.$store.state.langCodeX +
              '/' +
              product.productLink +
              '/' +
              product.companyUrlName.split(`-`).slice(0, 3).join(`-`) +
              '-' +
              product.companyId +
              '/' +
              product.countryName.toLowerCase().split(' ')[0] +
              '/export-products'
            "
          >
            <img
              :title="product.fullTitle"
              class=""
              :src="product.image"
              :alt="product.title"
            />
            <span :title="product.fullTitle">{{ product.title }}</span>
          </router-link>
        </div>
      </slide>

      <template #addons>
        <div class="sider-btn">
          <Navigation />
        </div>
      </template>
    </carousel>

    <hr />
  </div>

  <div
    v-show="hasCompanies && showLoader == false && companiesListData.length > 0"
    class="container"
  >
    <div class="companies-list-area" style="min-height: 1000px">
      <h3>{{ this.$store.getters.getWordLocale("FIRMALAR") }}</h3>
      <div class="companies-list">
        <div
          v-for="(company, cIndex) in companiesListData"
          :key="cIndex"
          class="company-item-home col-12"
        >
          <div
            class="col-12 p-0 m-0 d-flex align-items-center company-list-top-area"
          >
            <section class="d-none d-md-block">
              <img class="w-100" :src="company.logo" />
            </section>
            <div>
              <router-link
                :companyId="company.id"
                :to="
                  '/' + this.$store.state.langCodeX + '/company/' + company.link
                "
              >
                {{ company.fullName }}
              </router-link>
              <p>
                {{ company.description }}
              </p>
            </div>
          </div>
          <div class="col-12 company-list-bottom-area row m-0 pt-3">
            <article
              v-show="this.$store.state.domainLanguages.length > 1"
              class="d-flex align-items-center col-12 col-md-6 mb-3"
            >
              <p>{{ this.$store.getters.getWordLocale("txt_profili_oku") }}:</p>
              <router-link
                v-for="(profile, lIndex) in company.languages"
                :key="lIndex"
                :companyId="company.id"
                :to="'/' + profile + '/company/' + company.link"
              >
                <country-flag
                  :class="
                    this.$store.state.langCodeX == profile
                      ? 'selected-lang header-language'
                      : 'header-language'
                  "
                  v-show="
                    this.$store.state.domainLanguages.filter(
                      (q) => q.LangCode == profile
                    ).length > 0
                  "
                  :country="
                    profile == 'en' ? 'gb' : profile == 'ar' ? 'sa' : profile
                  "
                  size="normal"
                />
              </router-link>
            </article>
            <section class="col-12 col-md-6 p-0">
              <ul class="justify-content-start justify-content-sm-end">
                <li
                  v-for="(keyword, kIndex) in company.companyKeywords"
                  :key="kIndex"
                  v-show="kIndex < 3"
                >
                  <a href="javascript:;">{{ keyword }}</a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <div v-show="companiesListData.length > 0">
        <div class="d-flex justify-content-center more-companies-box">
          <router-link
            class="btn btn-large-primary-button"
            :to="'/' + this.$store.state.langCodeX + '/companies'"
            >{{ this.$store.getters.getWordLocale("txt_daha_fazla_firma") }}
          </router-link>
        </div>
      </div>

      <hr />
    </div>
  </div>

  <div v-show="hasLeads && showLeadsLoader == false" class="container">
    <div class="lead-list-area">
      <h3>{{ this.$store.getters.getWordLocale("TALEPLER") }}</h3>
      <div class="lead-list row m-0">
        <div
          class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
          v-for="(lead, lIndex) in leadListData"
          :key="lIndex"
        >
          <div class="lead-item-home">
            <div class="lead-item-home-header">
              <abbr>{{ lead.createTime }}</abbr>
              <div class="d-flex justify-content-between align-items-center">
                <router-link
                  class="lead-link"
                  :to="'/' + this.$store.state.langCodeX + '/lead/' + lead.link"
                >
                  <strong :title="lead.title">
                    {{
                      lead.title.length > 25
                        ? `${lead.title.substr(0, 25)}...`
                        : lead.title
                    }}
                  </strong>
                </router-link>

                <country-flag :country="lead.countryCode" size="normal" />
              </div>
            </div>

            <div class="lead-item-home-main">
              <p :title="lead.summary">
                {{
                  lead.summary.length > 30
                    ? `${lead.summary.substr(0, 30)}..`
                    : lead.summary
                }}
              </p>
              <ul>
                <li>
                  <i class="material-icons-outlined"> card_travel </i>
                  <span>
                    {{
                      lead.leadType == 0
                        ? this.$store.getters.getWordLocale("txt_alim_talebi")
                        : lead.leadType == 1
                        ? this.$store.getters.getWordLocale("txt_satis_teklifi")
                        : this.$store.getters.getWordLocale("txt_isbirligi")
                    }}
                  </span>
                </li>
                <li v-if="lead.credit > 0">
                  <i class="material-icons-outlined"> copyright </i>
                  <span
                    >{{ lead.credit }}
                    {{ this.$store.getters.getWordLocale("txt_kredi") }}</span
                  >
                </li>
                <li v-else>
                  <i class="material-icons-outlined"> handshake </i>
                  <span>{{
                    this.$store.getters.getWordLocale("txt_ucretsiz")
                  }}</span>
                </li>
              </ul>
            </div>

            <div class="lead-item-home-footer">
              <ul>
                <li
                  v-for="(keyword, lkIndex) in lead.keywords"
                  :key="lkIndex"
                  v-show="lkIndex < 5"
                >
                  <a href="javascript:;">{{ keyword }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-show="leadListData.length > 0">
        <div class="d-flex justify-content-center more-lead-box">
          <router-link
            class="btn btn-large-primary-button"
            :to="'/' + this.$store.state.langCodeX + '/leads'"
            >{{ this.$store.getters.getWordLocale("txt_daha_fazla_talep") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import CountryFlag from "vue-country-flag-next";
import "vue3-carousel/dist/carousel.css";
import moment from "moment";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  components: {
    ForieLoader,
    TeLoader,
    Carousel,
    Slide,
    Navigation,
    CountryFlag,
  },
  data() {
    return {
      selectedMainAndSubCategories: [],
      companiesMembershipDetails: [],
      listedCompaniesIdList: [],
      hasCompanies: false,
      hasLeads: false,
      hasProducts: false,
      showLeadsLoader: true,
      showLoader: true,
      leadsList: [],
      leadListData: [],
      selectedLeadTypes: [],
      selectedLeads: [],
      selectedLeadType: -1,
      companiesListData: [],
      vipMembershipList: [],
      selectedSegments: [],
      selectedBusinessSegment: 0,
      selectedCountries: [],
      selectedCountry: 0,
      selectedCompanies: [],
      selectedMainCategory: 0,
      selectedCategories: [],
      selectedSubCategory: 0,
      membershipType: 0,
      keywords: [],
      activation: 0,
      companiesList: [],
      productsList: [
        {
          companyId: 0,
          companyUrlName: "",
          productLink: "",
          countryName: "",
          image: "",
          title: "",
          fullTitle: "",
          description: "",
        },
      ],
      settings: {
        itemsToShow: 1.5,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  methods: {
    async getCompaniesList() {
      if (this.companiesListData.length > 0) {
        return;
      }
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompaniesListForDomains`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            activation: this.activation,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            membershipType: this.membershipType,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedCompanies:
              this.selectedCompanies.length == 0
                ? null
                : this.selectedCompanies,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            selectedSegments:
              this.selectedBusinessSegment > 0
                ? [this.selectedBusinessSegment]
                : this.selectedSegments.length == 0
                ? null
                : this.selectedSegments,
            vipMembershipList:
              this.vipMembershipList.length == 0
                ? null
                : this.vipMembershipList,
            search: "",
            page: 0,
            limit: 5,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companiesList = data))
        .catch((err) => console.log(err.message));

      this.$store.state.companiesListDataX = this.companiesList;
      this.buildCompaniesList(this.$store.state.companiesListDataX);
    },
    buildCompaniesList(companiesList) {
      this.productsList = [];
      this.listedCompaniesIdList = [];

      companiesList
        .filter((q) => q.Localizations.length > 0)
        .forEach((element) => {
          var companyId = parseInt(element.SecondaryId);
          this.listedCompaniesIdList.push(companyId);

          var companyName = element.Title;
          const dateObject = new Date(element.CreateTime);

          var endDate = moment(new Date(), "YYYY");
          var createTime = moment(String(dateObject)).format("YYYY");

          var diff = endDate.diff(createTime, "years");
          var years = "";
          if (diff != undefined && !isNaN(diff) && diff > 0) {
            years = diff;
          }

          var companyUrlName = `${companyName
            .toLowerCase()
            .trim()
            .split(" ")
            .join("-")}`;

          companyUrlName = companyUrlName.replace(/[^a-zA-Z0-9,-]/g, "");
          companyUrlName = companyUrlName.replace(/---/g, "-");
          companyUrlName = companyUrlName.replace(/--/g, "-");

          var isVip = element.IsVip;
          var countryName =
            element.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length == 0
              ? element.Country.filter((q) => q.LangCode == "en").length == 0
                ? element.Country.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name
                : element.Country.filter((q) => q.LangCode == "en")[0].Name
              : element.Country.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name;

          var countryCode =
            element.Country[0] != null && element.Country[0] != undefined
              ? element.Country[0].Icon
              : "";
          var logo =
            element.Logo == null
              ? this.$store.state.defaultLogoX
              : `https://cdn.turkishexporter.com.tr${element.Logo}`;

          logo = logo.toLowerCase();
          if (
            logo.indexOf(`companies/logo/1`) != -1 ||
            logo.indexOf(`companies/logo/logo`) != -1
          ) {
            logo = this.$store.state.defaultLogoX;
          }

          var companyDescription =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].DescriptionContent
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].DescriptionContent;
          companyDescription =
            companyDescription == null
              ? ""
              : companyDescription.length > 110
              ? `${companyDescription.substr(0, 110)}...`
              : companyDescription;

          var companyKeywords =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Keywords
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Keywords;
          companyKeywords =
            companyKeywords != null
              ? companyKeywords.length == 0
                ? ""
                : companyKeywords.split(",")
              : "";

          var languages = [];
          element.Localizations.forEach((loc) => {
            languages.push(loc.LangCode);
          });

          element.Products.forEach((pro) => {
            if (pro.Images.length > 0) {
              var image = pro.Images.length == 0 ? "" : pro.Images[0];
              if (image != undefined) {
                image = image.Image;
              }
              var id = parseInt(pro.Images[0]._id);
              var title =
                pro.Localizations.length == 0
                  ? ""
                  : pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Name
                  : pro.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Name;
              title = title.length > 10 ? `${title.substr(0, 10)}...` : title;
              var fullTitle =
                pro.Localizations.length == 0
                  ? ""
                  : pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Name
                  : pro.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Name;
              var description =
                pro.Localizations.length == 0
                  ? ""
                  : pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? pro.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Description
                  : pro.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Description;

              var productLink = `${fullTitle
                .toLowerCase()
                .trim()
                .split(" ")
                .join("-")}-${id}`;

              productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
              productLink = productLink.replace(/---/g, "-");
              productLink = productLink.replace(/--/g, "-");

              if (image != "") {
                this.productsList.push({
                  productLink: productLink,
                  companyUrlName: companyUrlName,
                  countryName: countryName,
                  companyId: companyId,
                  image: `https://cdn.forie.com${image}`,
                  title: title,
                  fullTitle: fullTitle,
                  description: description,
                });
              }
            }
          });

          var link = element.LinkString;
          this.companiesListData.push({
            companyId: companyId,
            link: link,
            logo: logo,
            name: companyName,
            fullName: companyName,
            description: companyDescription,
            languages: languages,
            isVip: isVip,
            countryName: countryName,
            countryCode: countryCode,
            companyKeywords: companyKeywords,
            years: years,
          });
        });

      this.showLoader = false;
      this.getCompaniesMembershipDetails();
    },
    async getLeadsList() {
      if (this.leadListData.length > 0) {
        return;
      }

      this.showLeadsLoader = true;
      this.leadListData = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLeadsListForDomains`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            selectedLeadType:
              this.selectedLeadType == -1 ? null : this.selectedLeadType,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedLeads:
              this.selectedLeads.length == 0 ? null : this.selectedLeads,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            search: "",
            page: 0,
            limit: 6,
            selectedLeadTypes: this.selectedLeadTypes,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadsList = data))
        .catch((err) => console.log(err.message));
      this.$store.state.leadsListDataX = this.leadsList;
      this.buildLeadsList(this.$store.state.leadsListDataX);
    },
    buildLeadsList(leadsList) {
      leadsList.forEach((element) => {
        var leadTitle =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Title
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Title;

        const dateObject = new Date(element.PublishTime);
        var createTime = dateObject.toLocaleString("tr-TR");

        var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
        endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
        createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss");

        var diff = endDate.diff(createTime, "days");
        if (diff == 0) {
          createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss").fromNow();
        } else {
          createTime = dateObject.toLocaleString("tr-TR");
        }

        var leadId = parseInt(element._id);
        var leadType = parseInt(element.Type);
        var credit = parseInt(element.Credit);
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";

        var leadSummary =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].ShortDescription
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].ShortDescription;
        leadSummary =
          leadSummary == null
            ? ""
            : leadSummary.length > 125
            ? `${leadSummary.substr(0, 125)}...`
            : leadSummary;

        var leadKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        leadKeywords = leadKeywords.split(",");
        var link = element.LinkString;
        this.leadListData.push({
          id: leadId,
          title: leadTitle,
          link: link,
          createTime: createTime,
          countryName: countryName,
          countryCode: countryCode !== null ? countryCode.toLowerCase() : "",
          summary: leadSummary,
          keywords: leadKeywords,
          leadType: leadType,
          credit: credit,
        });
      });

      this.showLeadsLoader = false;
      this.showLoader = false;
    },
    async getCompaniesMembershipDetails() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompaniesMembershipDetails`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: this.listedCompaniesIdList,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      result.forEach((element) => {
        var companyId = parseInt(element._id);
        var membershipName =
          element.CompanyActiveMembership.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        var membershipLogo = element.CompanyActiveMembership.Icon;

        this.companiesMembershipDetails.push({
          companyId: companyId,
          name: membershipName,
          logo: membershipLogo,
        });
      });
    },
  },
  mounted() {
    moment.locale(`${this.$store.state.langCodeX}`);

    var filterContent = this.$store.state.domainContentX.FilterContent;

    this.hasCompanies =
      filterContent.filter((q) => q.id == "1" && parseInt(q.status) == 1)
        .length > 0
        ? true
        : false;

    this.hasLeads =
      filterContent.filter((q) => q.id == "2" && parseInt(q.status) == 1)
        .length > 0
        ? true
        : false;

    this.hasProducts =
      filterContent.filter((q) => q.id == "3" && parseInt(q.status) == 1)
        .length > 0
        ? true
        : false;

    if (this.hasCompanies == false && this.hasProducts == false) {
      this.productsList = [];
    }
    // #region CompaniesFilter
    var companyContentX = this.$store.state.domainContentX.CompanyContent;
    this.activation = parseInt(companyContentX.Activation);
    var keywords = companyContentX.Keywords;
    this.membershipType = parseInt(companyContentX.MembershipType);
    var selectedCategories = companyContentX.SelectedCategories;
    var selectedCompanies = companyContentX.SelectedCompanies;
    var selectedCountries = companyContentX.SelectedCountries;
    var selectedSegments = companyContentX.SelectedSegments;
    var vipMembershipList = companyContentX.VipMembershipList;

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedCompanies.length > 0) {
      this.selectedCompanies = [];
      selectedCompanies.forEach((element) => {
        var companyId = parseInt(element.id);
        this.selectedCompanies.push(companyId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    if (selectedSegments.length > 0) {
      this.selectedSegments = [];
      selectedSegments.forEach((element) => {
        var segmentId = parseInt(element);
        this.selectedSegments.push(segmentId);
      });
    }

    if (vipMembershipList.length > 0) {
      this.vipMembershipList = [];
      vipMembershipList.forEach((element) => {
        var membershipId = parseInt(element);
        this.vipMembershipList.push(membershipId);
      });
    }

    if (this.hasCompanies || this.hasProducts) {
      if (this.$store.state.companiesListDataX.length == 0) {
        this.showLoader = true;
        this.getCompaniesList();
      } else {
        this.buildCompaniesList(this.$store.state.companiesListDataX);
      }
    }

    // #endregion

    // #region LeadsFilter
    var leadContentX = this.$store.state.domainContentX.LeadContent;
    if (leadContentX != null) {
      keywords = leadContentX.Keywords;

      selectedCategories = leadContentX.SelectedCategories;
      var selectedLeads = leadContentX.SelectedLeads;
      selectedCountries = leadContentX.SelectedCountries;
      this.selectedLeadTypes = leadContentX.SelectedLeadTypes;
      if (this.selectedLeadTypes.length > 0) {
        var temp = [];
        this.selectedLeadTypes.forEach((element) => {
          var type = parseInt(element);
          temp.push(type);
        });
        this.selectedLeadTypes = [];
        this.selectedLeadTypes = temp;
      }

      if (keywords.length > 0) {
        this.keywords = [];
        keywords.forEach((element) => {
          var text = element.text;
          this.keywords.push(text);
        });
      }

      if (selectedLeads.length > 0) {
        this.selectedLeads = [];
        selectedLeads.forEach((element) => {
          var leadId = parseInt(element.id);
          this.selectedLeads.push(leadId);
        });
      }

      if (selectedCategories.length > 0) {
        this.selectedCategories = [];
        selectedCategories.forEach((element) => {
          var categoryId = parseInt(element.categoryId);
          var mainCategoryId = parseInt(element.mainCategoryId);

          this.selectedCategories.push(categoryId);
          this.selectedMainAndSubCategories.push({
            mainCategoryId: mainCategoryId,
            categoryId: categoryId,
          });
        });
      }

      if (selectedCountries.length > 0) {
        this.selectedCountries = [];
        selectedCountries.forEach((element) => {
          var countryId = parseInt(element);
          this.selectedCountries.push(countryId);
        });
      }

      if (this.$store.state.leadsListDataX.length == 0) {
        this.getLeadsList();
      } else {
        this.buildLeadsList(this.$store.state.leadsListDataX);
      }
    }
    // #endregion
  },
};
</script>

<style scoped>
.carousel {
  margin-bottom: 45px;
  margin-top: 32px;
}
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--m3--sys--light--on-primary);
  color: rgb(0, 0, 0);
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 10px;
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}
.carousel__item a {
  width: 100%;
  margin: 0 auto;
}
.carousel__item span {
  display: flex;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  font-size: 16px;
  padding-top: 22px;
  padding-left: 16px;
  margin-top: 6px;
  padding-bottom: 16px;
  color: var(--m3--sys--light--on-surface);
}
.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  font-size: 2rem;
  color: #fff;
  border-radius: 0.75rem;
}

.desc-text {
  min-height: 125px;
}

.go-to-link {
  float: right;
  width: 100%;
}

.company-logo {
  width: 60px;
  height: 60px;
  border: 1px solid #d8d8d8;
  padding: 2px;
  background: white;
  margin: 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.languages {
  border: 1px solid #383a3c;
  border-radius: 4px;
  background: #202428;
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
}

.carousel button {
  background-color: #000 !important;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.carousel__pagination-button--active {
  background-color: red !important;
}

.carousel__item img {
  width: 130px;
  height: 130px;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.lead-country small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.sell {
  color: #34c5f3 !important;
  border: 1px solid #34c5f3 !important;
  margin-right: 3px;
  font-size: 12px;
  padding: 6px 10px;
}

.buy {
  color: #e71d36 !important;
  border: 1px solid #e71d36 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
}

.not-free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #daa520 !important;
  border: 1px solid #daa520 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #16a448 !important;
  border: 1px solid #16a448 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

a {
  color: white;
}

.seo-section {
  border: 0px;
  border-radius: 4px;
  color: #202428;
  background-color: #ffffff;
  padding: 8px;
}

.company-card {
  min-height: 245px;
}

.lead-sell-request {
  border: 1px solid var(--m3--source---seed) !important;
}

.lead-sell-request > span {
  color: var(--m3--source---seed) !important;
}

.lead-free-box {
  border: 1px solid var(--green-500) !important;
}

.lead-free-box > span {
  color: var(--green-500) !important;
}
.lead-free-box > i {
  color: var(--green-500) !important;
}

.page-laoder {
  position: relative !important;
}

.visibility {
  visibility: hidden !important;
}
.lead-link {
  color: #005eb5 !important;
}
</style>
